import { CountriesState } from '@core/locations/store/states/countries.state';
import { StatesState } from '@core/locations/store/states/states.state';

export const locationsState = [CountriesState, StatesState];
